module.exports = __webpack_public_path__ + "img/icon-recipients-white.792847f1.svg";